import { useEffect } from "react";

import { bootstrapConversionAnalytics } from "./bootstrapConversionAnalytics";
import type { ConversionAnalyticsConfig } from "./bootstrapConversionAnalytics";

export const useInitializeConversionAnalytics = (
  config: ConversionAnalyticsConfig | null | undefined,
  scopeId: string | null | undefined,
  analyticsTrackingAllowed: boolean
): void => {
  const enabled = config?.enabled;
  const gtmContainerId = config?.gtmContainerId;
  const ga4MeasurementId = config?.ga4MeasurementId;
  const metaPixelId = config?.metaPixelId;

  useEffect(() => {
    bootstrapConversionAnalytics(
      {
        enabled,
        gtmContainerId,
        ga4MeasurementId,
        metaPixelId,
      },
      { analyticsTrackingAllowed, scopeId }
    );
  }, [
    enabled,
    gtmContainerId,
    ga4MeasurementId,
    metaPixelId,
    scopeId,
    analyticsTrackingAllowed,
  ]);
};
